export class Client {
  cliente_id: number;
  nombres: string;
  apellidos: string;
  ci_nit: string;
  direccion: string;
  email: string;
  latitud: string;
  longitud: string;
  foto: string;
  celular: string;
}
